import type { SupportedRepubName } from './types';

export type TrendsConfig = {
  defaultEventDisplayName: string;
  defaultRanges: Partial<Record<'sportsData.hitRates.last10', `${number}:${number}`>>;
  last10: string;
  last20: string;
  last5: string;
};

/**
 * Trends configurations for each republic
 */
export const TRENDS_CONFIGS = {
  GZ: {
    defaultEventDisplayName: 'Serie A',
    defaultRanges: { 'sportsData.hitRates.last10': '40:100' },
    last5: 'Ultime 5',
    last10: 'Ultime 10',
    last20: 'Ultime 20',
  },
  OC: {
    defaultEventDisplayName: 'EPL',
    defaultRanges: { 'sportsData.hitRates.last10': '60:100' },
    last5: 'Last 5',
    last10: 'Last 10',
    last20: 'Last 20',
  },
  US: {
    defaultEventDisplayName: 'NFL',
    defaultRanges: { 'sportsData.hitRates.last10': '60:100' },
    last5: 'Last 5',
    last10: 'Last 10',
    last20: 'Last 20',
  },
  WS: {
    defaultEventDisplayName: 'All',
    defaultRanges: { 'sportsData.hitRates.last10': '60:100' },
    last5: 'Last 5',
    last10: 'Last 10',
    last20: 'Last 20',
  },
  // ES: {
  //   defaultEventDisplayName: 'All',
  //   last5: 'Últimos 5',
  //   last10: 'Últimos 10',
  //   last20: 'Últimos 20',
  // },
} satisfies Record<SupportedRepubName, TrendsConfig>;
